import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const IconUser = (props) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <Path
      fill="#001689"
      d="M12.143 13.571H7.857A7.857 7.857 0 0 0 0 21.429a1.429 1.429 0 0 0 1.429 1.429h17.143A1.429 1.429 0 0 0 20 21.429a7.857 7.857 0 0 0-7.857-7.858Zm-9.956 7.143a5.72 5.72 0 0 1 5.67-5h4.286a5.723 5.723 0 0 1 5.67 5ZM10 11.429a5.714 5.714 0 0 0 5.714-5.714A5.714 5.714 0 0 0 10 0a5.714 5.714 0 0 0-5.714 5.714A5.714 5.714 0 0 0 10 11.429Zm0-9.286a3.576 3.576 0 0 1 3.571 3.571A3.576 3.576 0 0 1 10 9.286a3.576 3.576 0 0 1-3.571-3.571A3.576 3.576 0 0 1 10 2.143Z"
    />
  </Svg>
);
export default IconUser;
